import { render, staticRenderFns } from "./OAuthToken.vue?vue&type=template&id=71a1c91a&"
import script from "./OAuthToken.vue?vue&type=script&lang=js&"
export * from "./OAuthToken.vue?vue&type=script&lang=js&"
import style0 from "./OAuthToken.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports